function mask(phoneNumber: string) {
  if (!phoneNumber) {
    return '';
  }

  return phoneNumber
    .replace(/\D/g, '')
    .replace(/^(\d{2})\B/, '($1) ')
    .replace(/(\d{1})?(\d{4})(\d{4})/, '$1$2-$3').slice(0, 15);
}

const unMask = (value: String) => {
  if (!value) {
    return "";
  }

  return value.replace(/\D/g, '');
}

export default {
  mask,
  unMask,
}
